var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.095 0.0260602C12.827 0.171279 14.514 0.699933 16.0508 1.59547C21.7403 4.91135 23.6884 12.2537 20.405 17.9945C17.1206 23.7365 9.84458 25.7056 4.15367 22.389C2.60566 21.4869 1.30099 20.2645 0.30703 18.8076C-0.338655 17.8609 0.0768562 16.5518 1.15299 16.1628L1.88346 15.8887C5.41581 14.5068 7.21978 12.9579 8.28676 10.902C9.51909 8.52751 9.86812 5.90734 8.96442 2.16969C8.68903 1.03036 9.58045 -0.0606282 10.7485 0.00262275L11.095 0.0260602ZM12.8236 3.95094C13.2167 7.24131 12.6889 9.98643 11.3698 12.5282C10.0331 15.1037 7.93482 16.9825 4.6872 18.4966C5.06116 18.8131 5.46414 19.1006 5.89571 19.3521C9.91946 21.6969 15.0654 20.3059 17.39 16.2421C19.6426 12.3038 18.4176 7.30286 14.6793 4.8614L14.3096 4.63333C13.8316 4.35471 13.334 4.12779 12.8236 3.95094Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.5f0cd245033dd1f742b9d530f674b64c.svg";
export { ForwardRef as ReactComponent };